const WIFI7 = window?.sessionStorage?.getItem('isWIFI7') === 'true' ;

export const SignIn = {
    onPageLoad: 'SIGNIN_PAGE_LOAD',
    signInRequest: 'INITAL_SIGNIN',
    signInResponse: 'AFTER_SIGNIN',
    profilePullSuccess: 'PROFILE_SUCCESS',
    updateFlowType: 'UPDATE_FLOWTYPE',  
    isECSmartcart: 'EC_SMARTCART',
    isECSmartCartLoaded: 'EC_SMARTCART_LOADED',
    isECSmartCartEnabled: 'EC_SMARTCART_ENABLED'  
}


export const CheckLQ = {
    onPageLoad: 'LQ_PAGE_LOAD',
    onZipCodeChange: 'LQ_ON_ZIPCODE_CHANGE',
    onZipcodeSelected: 'LQ_ON_ZIPCODE_SELECTED',
    onStreetAddrChange: 'LQ_ON_STREETADDR_CHANGE',
    onStreetAddrSelected: 'LQ_ON_STREETADDR_SELECTED',
    setSelectedState: 'LQ_SETSELECTEDSTATE',
    onUnitChange: 'LQ_ON_UNIT_CHANGE',
    onUnitSelected: 'LQ_ON_UNIT_SELECTED',
    onExistingService: 'LQ_EXISTING_SERVICE',
    onCheckLQClick: 'LQ_ON_CHECK_AVAILABILITY_CLICK',
    onRetrieveQualdetails: 'LQ_ON_RETRIEVE_QUALDETAILS',
    onLoaderStatus: 'LQ_LOADER_ACTIVE',
    newService:'LQ_NEWSERVICE',
    lqRevisit: 'LQ_REVISIT',
    lboRedirectOOF: 'LBOREDIRECTOOF',
    redirectingFYH: 'REDIRECTINGFYH',
    showLQ:'SHOW_LQ',
    signInAs:'LQ_SIGNIN_INPUT',
    updateInitLoad:'UPDATE_INITLOADSEC',
    validateSignin:'VALIDATE_SIGNIN',
    ResetApiCount: 'RESETAPICOUNT',
    errorSigninMH: 'ERROR_SIGNIN_MH',
    skipfornowMH:'SKIPFORNOWMH',
    signinMHSuccess: 'SIGNINMHSUCCESS',
    updateToken:'UPDATE_TOKEN',
    updateCouponLQPage:'UPDATE_COUPON_LQPAGE',
    updateCouponFlowType:'UPDATE_COUPON_FLOW_TYPE',
    updatecouponFlowStatus:'UPDATE_COUPON_FLOW_STATUS',
    onShowZipLoader:'LQ_ON_SHOW_ZIP',
    onShowStreetLoader : 'LQ_ON_FETCHING_UNITS_FOR_STREET',
    validateSignInCoupon:'VALIDATE_SIGNINCOUPON',
    phoneNumCheck:'PHONENUM_SIGNINCOUPON_CHECK',
    mtnSignInErr:'MTN_SIGNERROR',
    mtnSignIn:'MTN_SIGN',    
    chatEnable:'CHATAENABLE',  
    isFCPflow: 'IS_FCP_FLOW',
    updateSigninBtnStatus:'UPDATE_SIGNIN_BTN_STATUS',
    updateBannerType:'UPDATE_BANNER_TYPE',
    showLQonAdrEntry:'SHOWLQ_ONADDRESSENTRY',
    isoneLQFlow: 'IS_ONELQ',
    isQAMLessFlow:'IS_QAMLESS',
    isBuffalloDMA:'IS_BUFFALLODMA',
    isamazonmover:'IS_AMAZONMOVER',
    isoneLQFlowDev: 'IS_ONELQDEV',
    isoneLQFlowYellowZone: 'IS_ONELQYELLOWZONE',    
    adrEntered: 'ADDRESS_ENTERED',
    unitEntered: 'UNIT_ENTERED',
    isMultiadr: 'IS_MULTIADR',
    skipCaptcha: 'SKIP_CAPTCHA',
    suggestedAddress : 'SUGGESTED_ADDRESS',
    captchaChanged : 'captchaChange',
    showCaptchaLBOFromVisitId :'SHOWCAPTCHAFROMVISITID',
    checkfor5G :'CHECKFOR5G_RES',
    TriggerLQ : 'TRIGGER_LQ',
    isCaptchaAPI : 'ISCAPTCHAAPI',
    updateAgencyId : 'UPDATEAGENCYID',
    update5GRecommended : 'UPDATE5GRECOMMENDED',
    cartFirstAddition : 'CARTFIRSTADDITION',
    update4GRecommended : 'UPDATE4GRECOMMENDED',
    showStadiaOffer :'SHOW_STADIA_OFFER',
    updateIsVendorVisit : 'UPDATE_IS_VENDOR_VISIT',
    updateAccessCode: 'UPDATE_ACCESS_CODE',
    updateStartdatetimestamp: 'UPDATE_STARTDATE_TIMESTAMP',
    resetLqData : 'RESET_LQ_DATA',
    sweetnerMsgMFRT: 'SWEETNERMSG_MFRT',
    dtmTransactionsMFRT: 'DTMTransactions_MFRT',
    MFRTEligible: 'MFRTEligible',
    MFRTVerified: 'MFRTVerified',
    mfrtInitialLoad: 'MFRT_INITIAL_LOAD',
    MFRTCompleted: 'MFRTCompleted',
    MFRTMovesFlow: 'MFRTMovesFlow',
    MFRTDiscountEligible: 'MFRTDiscountEligible',
    MFRTProfileDiscountEligible:'MFRTProfileDiscountEligible',
    ValidateApiCount: 'VALIDATEAPICOUNT',
    MNHPDCData: 'MNHPDCData',
    MNHFlow: 'MNHFlow',
    MNHGigQualified: 'MNHGigQualified',
    MNHChangeAdrFlow: 'MNHChangeAdrFlow',
    MNHQueryString: 'MNHQueryString',
    mnhCheckoutInfo:'MNH_CHECKOUTINFO',
    MNHONECLICKFLOW:'MNH_ONECLICKFLOW',
    MNHReserveSIDueDate: 'MNH_RESERVE_SI_DUEDATE',
    MNHPFBAUTOPAY:'MNH_PFB_AUTOPAY',
    MNHSHOWCARTONCHECKOUT:'MNH_SHOW_CART_ON_CHECKOUT',
    MNHCREDITCOMPLETED:'MNH_CREDIT_COMPLETED',
    MNHAUTOPAYDEFAULTTAGGIMG : 'MNH_AUTOPAY_OPTION_CLICK_TAGGING_FIRED',
    showMarvelOffer : 'SHOW_MARVEL_OFFER',
    updateMFRTType : 'UPDATE_MFRT_TYPE',
    MilvetHeaderhide : 'MILVET_HEADER_HIDE',
    PushNotificationEnable : 'PUSHNOTIFICATIONENABLE',
    TWSLQ2:'TWSLQ2'

}

export const DOFlow = {
    onDoFlowInit:'DO_DOFLOWINIT',
    onDoFlowCreation:'DO_FLOWCREATION',
    onDoContract:'DO_CONTRACT',
    onSelectedCoreService:'DO_SELECTEDCORESERVICE',
    onDOStatus:'DOSTATUS',
    onDOError:'DOERROR',
    onEmptyDoFlowStatus : 'EMPTYDOFLOWSTATE'
}

export const HOAFlow = {
    onHoaFlowInit:'HOA_DOFLOWINIT',
    onHoaFlowCreation:'HOA_FLOWCREATION',
    onEmptyHoaFlowStatus : 'EMPTYHOAFLOWSTATE'
}

export const XPSEntry ={    
    retrieveSmartCart:'RETRIEVE_SAVECART',
    resumeSavedMon:'RESUMESAVED_MON',    
    resumeMonErr:'RESUMEMON_ERROR',
    updateLQFromXPSEntry: 'UPDATE_LQ',
    incorrectMonErr: 'INCORRECTMON_ERROR',
    showMTNEmailSec:'UPDATE_MTN_EMAIL_SEC_STATUS',
    sendCartNum:'XPS_SENDCART_NUM',
    sendSmsorEmailErr:'XPS_SENDSMSOREMAILERROR',
    sendSmsorEmailErrAttempts:'XPS_SENDSMSOREMAILERRATTEMPTS',
    sendSmsorEmailAttemptsError:'XPS_SENDSMSOREMAILATTEMPTSERROR',
    retrieveByMon:'RETRIEVE_MON',
    retrieveByMtn:'RETRIEVE_MTN',
    retrieveByEmail:'RETRIEVE_EMAIL',
    enableSmartCartLBO:'ENABLE_SMARTCART_LBO',
    isMemoryClearedForNewVisit: 'MEMORY_CLEARED_FOR_NEW_VISIT',
    isMemoryClearedForChatVisit: 'MEMORY_CLEARED_FOR_CHAT_VISIT',   
    xpsCaptchaChanged : 'XPSCAPTCHA_STATE_CHANGE',
    xpsShowCaptchaLBOFromVisitId :'XPSSHOWCAPTCHAFROMVISITID',
    showLoaderOnSCPageStart:  'SHOW_LOADER_ONSC_PAGESTART'
}

export const Save ={
    saveModalInput:'SAVEMODAL_INPUT',
    saveLqEmailInput:'SAVELQEMAIL_INPUT',
    saveLqMtnInput:'SAVELQMTN_INPUT',
    saveMHUserIdInput: 'SAVE_MHUSERIDINPUT',
    saveMHPasswordInput: 'SAVE_MHPASSWORDINPUT',
    processSaveCart:'PROCESS_SAVECART',
    smartSave:'SMART_SAVE',
    saveInvoked:'SAVE_INVOKED',
    helpSave:'HELP_SAVE',
    creditDone:'CREDIT_DONE',
    expiryDate:'EXPIRY_DATE',
    validateInput:'VALIDATE_INPUT',
    emailError:'EMAIL_ERROR',
    mtnError:'MTN_ERROR',
    retrieveSmartCart:'RETRIEVE_SAVECART',
    resumeSavedMon:'RESUMESAVED_MON',
    sendCartNum:'SENDCART_NUM',
    resumeMonValueErr:'RESUMEMONVALUE_ERROR',
    resumeMonErr:'RESUMEMON_ERROR',
    sendCartErr:'SENDCART_ERROR',
    updateResumeAttempts:'UPDATE_RESUME_ATTEMPTS',
    resumeMonAttemptErr:'RESUME_ATTEMPT_ERROR',
    invalidMTNErr:'INVALID_MTN_ERROR',
    sendCartMTNErr:'CART_MTNERROR',
    sendCartEmailErr:'CART_EMAILERROR',
    sendSmsorEmail:'SENDSMSOREMAIL',
    sentSmsorEmail:'SENTSMSOREMAIL',
    issmartcartFlow: 'IS_SMARTCART_FLOW',
    smartCartFlowFlag: 'true',
    sentSmsorEmailSuccess: 'SENT_SMS_OR_EMAIL_SUCCESS',
    isTNUpdatedForResumeSmartCart: 'IS_TNUPDATED_FORRESUMECART',
    resumeInternetAdded: 'RESUME_ISINTERNETADDED',
    resumeTvAdded: 'RESUME_ISTVADDED',
    resumeVoiceAdded: 'RESUME_ISVOICEADDED',
    cancelSmartcart : 'CANCEL_SAVED_CART',
    cancelMon : 'CANCEL_MON',
    loadTNForSCResume: 'LOADTN_FOR_SCRESUME',
    pdcSmartCartMON : 'PDC_SMARTCART_MON',
    scResumeSourceCaptured:'SC_RESUME_SOURCE',
    enableSmartCartLBO:'ENABLE_SMARTCART_LBO',
    onValidateSmartSaveEmail: 'VALIDATE_SMARTSAVE_EMAIL',
    backInvoked: 'BACK_INVOKED'
}

export const Deposit ={
    validateDeposit:'CO_VALIDATEDEPOSIT',
    depositPaymentClicked:'PAYMENT_CLICKED',
    depositAddressCheck:'DEPOSIT_ADDRESS_CHECK',
    depositdebitCheck:'DEPOSIT_DEBIT_CHECK',
    onUpdateDeposit:'SO_DEPOSIT_SUCCESS',
    updateDepositAttempts:'UPDATE_DEPOSIT_ATTEMPTS',
    updateDepositStatus:'UPDATE_DEPOSIT_STATUS',
    fNameErr: 'FNAME_ERR',
    lNameErr: 'LNAME_ERR',
    cTypeErr: 'CTYPE_ERR',
    cNumErr: 'CNUM_ERR',
    cVVErr: 'CVV_ERR',
    expMonthErr: 'EXPMONTH_ERR',
    expYearErr: 'EXPYEAR_ERR',
    cityErr: 'CITY_ERR',
    streetErr:'STREET_ERR',
    stateValErr:'STATEVAL_ERR',
    zipErr:'ZIP_ERR'

}

export const FinalBill ={
    finalBillPayCheck:'PAY_CHECK',
    finalBillPayNoCheck:'PAY_NOCHECK',
    finalBilldebitCheck:'FB_DEBITCHECK',
    finalBillAddressCheck:'FB_ADDRESSCHECK',
    validateFinalBill:'VALIDATEFINALBILL',
    onUpdateFinalBill:'FB_RESPONSE',
    finalBillStatus : 'FINALBILL_STATUS',
    updateFinalBillOption:'UPDATE_FINAL_BILL_OPTION',
    fNameErr: 'FNAME_ERROR',
    lNameErr: 'LNAME_ERROR',
    cTypeErr: 'CTYPE_ERROR',
    cNumErr: 'CNUM_ERROR',
    cVVErr: 'CVV_ERROR',
    expMonthErr: 'EXPMONTH_ERROR',
    expYearErr: 'EXPYEAR_ERROR',
    cityErr: 'CITY_ERR',
    streetErr:'STREET_ERR',
    stateValErr:'STATEVAL_ERR',
    zipErr:'ZIP_ERR'
}

export const FutureNotification = {
    fNameErr: 'FN_FNAME_ERR',
    lNameErr: 'FN_LNAME_ERR',
    emailErr: 'FN_EMAIL_ERR',
    mtnErr: 'FN_MTN_ERR',
    ftvCheckErr: 'FN_FTVCHECK_ERR',
    ftvCheck: 'FN_FTVCHECK',
    validateInput:'FN_VALIDATE_INPUT',
    mtn:'FN_MTN',
    validationsucess:"FNVALIDATIONSUCESS",
    validationfailure:"FNVALIDATIONFAIL"    ,
    intialstatusbackendcall:"FNVALIDATIONINTIAL"    
}

export const ConnectionEmployee = {
    fNameErr: 'CE_FNAME_ERR',
    lNameErr: 'CE_LNAME_ERR',
    emailErr: 'CE_EMAIL_ERR',
    cemailErr: 'CE_CEMAIL_ERR',
    stateErr:'CE_STATE_ERR',
    stateExclusionErr:'CE_STATEEXCLUSION_ERR',
    stateExclusionList:",AL,AK,AR,CA,CO,FL,GA,HI,IA,KS,KY,LA,MI,MS,MO,MT,NE,NM,NC,ND,OK,SD,TN,TX,UT,WV,WY,ME,NH,VT,MN",
    mtnErr: 'CE_MTN_ERR',
    validateInput:'CE_VALIDATE_INPUT',  
    mtn:'CE_MTN'  ,
    enterpriseIDErr:'CE_ENTERPRISEID_ERR',
    EnterpriseIDContinue:'ENTERPRISEIDCONTINUE',
    EnterpriseIDToken:'ENTERPRISEIDTOKEN',
    validateEmployeeResponse:'VALIDATE_EMPLOYEE_RESPONSE',
    validateEmployeeResponseError:'VALIDATE_EMPLOYEE_RESPONSEERROR',
    validateEmployeeSystemResponseError:'VALIDATE_EMPLOYEE_SYSTEMRESPONSEERROR',
    generateEmployeeTokenError:'GENERATEEMPLOYEETOKENERROR',
    eidPageErr:'EID_PAGE_ERR'
}

export const MHSignin = {
    pageLoad: 'SI_PAGE_LOAD',
    onSigninClick: 'SI_SIGNIN_CLICKED',
    onSkipfornowClick: 'SI_SKIPFORNOW_CLICKED',
    onBackClick: 'SI_BACK_CLICKED',
}

export const ConnectionAffinity = {
    fNameErr: 'CA_FNAME_ERR',
    lNameErr: 'CA_LNAME_ERR',
    emailErr: 'CA_EMAIL_ERR',
    cemailErr: 'CA_CEMAIL_ERR',
    stateErr:'CA_STATE_ERR',
    stateExclusionErr:'CA_STATEEXCLUSION_ERR',
    stateExclusionList:",AL,AK,AR,CA,CO,FL,GA,HI,IA,KS,KY,LA,MI,MS,MO,MT,NE,NM,NC,ND,OK,SD,TN,TX,UT,WV,WY,ME,NH,VT,MN",
    mtnErr: 'CA_MTN_ERR',
    companyErr: 'CA_COMPANY_ERR',
    ssnErr: 'CA_SSN_ERR',
    validateInput:'CA_VALIDATE_INPUT',  
    mtn:'CA_MTN',
    validateAffinityResponse:'VALIDATE_AFFINITY_RESPONSE',
    validateAffinityResponseError:'VALIDATE_AFFINITY_RESPONSEERROR',
    validateAffinitySystemResponseError:'VALIDATE_AFFINITY_SYSTEMRESPONSEERROR',
    updateCompanyList:'UPDATE_COMPANY_LIST',
    updateCompanyListStatus:'UPDATE_COMPANY_LIST_STATUS',
    updatecustomerTokenDetails:'UPDATE_CUSTOMER_TOKEN_DETAILS',
}
export const ConnectionGetAffinity = {
    lNameErr: 'CGA_LNAME_ERR',
    emailErr: 'CGA_EMAIL_ERR',
    cemailErr: 'CGA_CEMAIL_ERR',
    stateErr:'CGA_STATE_ERR',
    stateExclusionErr:'CGA_STATEEXCLUSION_ERR',
    stateExclusionList:",AL,AK,AR,CA,CO,FL,GA,HI,IA,KS,KY,LA,MI,MS,MO,MT,NE,NM,NC,ND,OK,SD,TN,TX,UT,WV,WY,ME,NH,VT,MN",
    validateInput:'CGA_VALIDATE_INPUT',  
    validateGetAffinityResponse:'VALIDATE_GETAFFINITY_RESPONSE',
    validateGetAffinityResponseError:'VALIDATE_GETAFFINITY_RESPONSEERROR',
    validateGetAffinitySystemResponseError:'VALIDATE_GETAFFINITY_SYSTEMRESPONSEERROR',
    updateURLTagValue:'UPDATE_URLTAG_VALUE'
}
export const Connection = {
    Employee:'EMPLOYEE',
    Affinity:'AFFINITY',
    Retiree:'RETIREE',
    Association:'ASSOCIATION',
    GetAffinity:'GETAFFINITY',
    fileName:'FILE_NAME',
    fileNameErr:'FILE_NAMEERR',
    uploadFileInput:'UPLOADFILEINPUT',
    uploadFile:'UPLOADFILE',  
    proofUpload :'PROOFUPLOAD',
    fileSizeErr:'FILE_SIZE_ERR',
    connectionStateReset : 'CONNECTION_STATE_RESET'
}
export const ConnectionRetiree = {
    lNameErr: 'CR_LNAME_ERR',
    emailErr: 'CR_EMAIL_ERR',
    cemailErr: 'CR_CEMAIL_ERR',
    stateErr:'CR_STATE_ERR',
    stateExclusionErr:'CR_STATEEXCLUSION_ERR',
    stateExclusionList:",AL,AK,AR,CA,CO,FL,GA,HI,IA,KS,KY,LA,MI,MS,MO,MT,NE,NM,NC,ND,OK,SD,TN,TX,UT,WV,WY,ME,NH,VT,MN",
    validateInput:'CR_VALIDATE_INPUT',  
    validateRetireeResponse:'VALIDATE_RETIREE_RESPONSE',
    validateRetireeResponseError:'VALIDATE_RETIREE_RESPONSEERROR',
    validateRetireeSystemResponseError:'VALIDATE_RETIREE_SYSTEMRESPONSEERROR',
    RetireeToken:'RETIREETOKEN',
    generateRetireeTokenError:'GENERATERETIREETOKENERROR',
    updateLastName:'UPDATE_LAST_NAME',
    updateEid:'UPDATE_EID',
    updateLastNameStatus:'UPDATE_LNAME_STATUS',
    updateRetireeTokenErrMsg:'UPDATE_RETIREE_TOKEN_ERRMSG'
}

export const ConnectionAssociation = {
    orgNameErr: 'CAS_LNAME_ERR',
    validateInput:'CAS_VALIDATE_INPUT', 
    isEligible:'CAS_ISELIGIBLE',
    memberIDErr:'CAS_MEMBERID_ERR',
    cmemberIDErr:'CAS_CMEMBERID_ERR',
    lNameErr: 'CAS_LNAME_ERR',
    emailErr: 'CAS_EMAIL_ERR',
    cemailErr: 'CAS_CEMAIL_ERR',
    stateErr:'CAS_STATE_ERR',
    stateExclusionErr:'CAS_STATEEXCLUSION_ERR',
    stateExclusionList:",AL,AK,AR,CA,CO,FL,GA,HI,IA,KS,KY,LA,MI,MS,MO,MT,NE,NM,NC,ND,OK,SD,TN,TX,UT,WV,WY,ME,NH,VT,MN",
    validateAssociationResponse:'VALIDATE_ASSOCIATION_RESPONSE',
    validateAssociationResponseError:'VALIDATE_ASSOCIATION_RESPONSEERROR',
    validateAssociationSystemResponseError:'VALIDATE_ASSOCIATION_SYSTEMRESPONSEERROR',
    updateAuthKeyValue:'UPDATE_AUTHKEY_VALUE',
    updateCompanyName:'UPDATE_COMPANY_NAME',
    updateDisplayFieldName:'UPDATE_DISPLAY_FIELD_NAME',
    associateFieldErr:'ASSOCIATE_FIELD_ERR',
    confirmassociateFieldErr:'CONFIRM_ASSOC_FIELD_ERR'
}

export const BuildProduct ={
    socInvoked:'SOC_INVOKED',
    monInvoked:'MON_INVOKED',
    cutomeRouterCheck:'CUSTOMROUTER_CHECK',
    updateCheckoutBtnStatus:'UPDATE_CHECKOUTBTN_STATUS',
    toggleBatteryMsg:'TOGGLE_BATTERYMESSAGE',
    toggleDctMsg:'TOGGLE_DCTMESSAGE',
    contractInSmartCart: 'CONTRACT_SELECTED_IN_SC',
    buildprodLoaded:'BUILDPRODUCT_LOADED',
    monNo: 'MON_GENERATION',
    updateContractAccordionStatus:'UPDATE_CONTRACT_ACCORDION_STATUS',
    saveUpsell:'SAVE_UPSELL_RECOMMENDATIONS',
    upsellCallStatus:'UPSELL_CALL_STATUS',
    upsellCTA:'UPSELL_CTA',
    checkoutBtnSelection:'CHECKOUT_BUTTON_CLICK',
    isGPONIONTEligible:'GPON_IONT_ELIGIBLE',
    isBostonDMA: 'BOSTONDMA',
    isBannerChecked: 'BANNERCHECKED',
    isSmartCartFlow: 'SMARTCART_FLOW',
    isMarvelOfferInCart: 'MARVEL_INCART',
    isIdleTimeCheckout: 'IDLE_CHECKOUT',
    previousSelectedSpeed: 'PREVIOUS_SPEED',
    isMarvelInPreviousSelSpd:'MARVEL_IN_PREVIOUS_SPEED',
    utdProductTypeValue: 'ULTIMATETESTDRIVE',
    ultimateProductTypeValue: 'ULTIMATE',
    toggleTVMoreOpt: 'TOGGLE_TV_MOREOPTION',
    SweetnerMsg:'SWEETNER_NOTIFICATION',
    fcpSeeDetails:'FCPSEEDETAILS',
    showStadiaOffer :'SHOW_STADIA_OFFER',
    AutoAddStadiaGigToCart : 'AUTO_ADD_GIG_TO_CART',
    AutoAddStadiaOfferToCart : 'AUTO_ADD_STADIA_TO_CART',
    AutoAdd100MToCart : 'AUTO_ADD_100M_TO_CART',
    clearBuildProductState: 'CLEARBUILDPRODUCTSTATE',    
    showMarvelOffer : 'SHOW_MARVEL_OFFER',
    updateMFRTType : 'UPDATE_MFRT_TYPE',
    AutoAddMarvelGigToCart : 'AUTO_ADD_GIG_TO_CART',
    AutoAddMarvelOfferToCart : 'AUTO_ADD_MARVEL_TO_CART',
    toggleRouterMoreOpt:'TOGGLE_ROUTER_MOREOPTION',
    updateContactInfo:'UPDATE_CONTACT_INFO',
    updateClickStatus:'UPDATE_CLICK_FLAG',
    emailValidation:'UPDATE_EMAIL_VALIDATION',
    emailRegex:'UPDATE_EMAIL_REGEX',
    emailErr:'EMAIL_ERROR',
    UpsellService :{
        tv:'VID',
        data:'',
        datatv:'',
        datavoice:'',
        tvvoice:''

    }
}

export const ConfirmRequest = {
    onNameValidation: 'ON_NAME_VALIDATION',
    updateContactInfo: 'UPDATE_CONTACT_INFO',
    emailValidation:'UPDATE_EMAIL_VALIDATION',
    updateClickStatus:'UPDATE_CLICK_FLAG',
    emailRegex:'UPDATE_EMAIL_REGEX',
    updateFormattedphone: 'UPDATE_FORMATTEDPHONE',
    updateNameInfo: 'UPDATE_NAME_INFO',
    updateNsiNameInfo: 'UPDATE_NSI_NAME_INFO',
    onContactValidation: 'ON_CONTACT_VALIDATION',
}

export const CheckOut = {
    onValidateCartSuccess: 'CO_VALIDATE_CART_SUCCESS',
    onValidateCartFailure: 'CO_VALIDATE_CART_FAILURE',
    ftcChecked: 'FTC_CHECK',
    tosChecked: 'TOS_CHECK',
    tosMonthlyServiceDisclosureChecked:'MSD_CHECK',
    privacyChecked:'PRIVACY_CHECK',
    hdpChecked:'HDP_CHECK',
    homeSecurityChecked:'HOME_SECURITY_CHECKED',
    homeSecureChecked: 'HOME_SECURE_CHECK',
    homeSecurePlusChecked: 'HOME_SECURE_PLUS_CHECK',
    tosVoiceChecked: 'TOS_VOICE_CHECK',
    tosViewed: 'TOS_VIEWED',
    tosAccordionOpen: 'TOS_ACCORDION_OPEN',
    onNameValidation: 'ON_NAME_VALIDATION',
    updateContactInfo: 'UPDATE_CONTACT_INFO',
    emailValidation:'UPDATE_EMAIL_VALIDATION',
    updateClickStatus:'UPDATE_CLICK_FLAG',
    emailRegex:'UPDATE_EMAIL_REGEX',
    updateFormattedphone: 'UPDATE_FORMATTEDPHONE',
    updateFormattedFSMDNphone: 'UPDATE_FORMATTEDPHONE_MDN',
    updateNameInfo: 'UPDATE_NAME_INFO',
    onContactValidation: 'ON_CONTACT_VALIDATION',
    updateBillingAddrInfo: 'UPDATE_BILLING_ADDR_INFO',
    onBillingAddressValidation: 'ON_BILLING_ADDRESS_VALIDATION',
    onBillingAddressSystemError: 'ON_BILLING_ADDRESS_SYSTEMERROR',
    onUpdateExternalCreditCheck: 'UPDATE_EXTERNAL_CREDITCHECK',
    disableExternalCreditCheck: 'DISABLE_EXTERNAL_CREDITCHECK',
    noSSNCheck: 'NO_SSN_CHECK',
    enableSSNCheck: 'ENABLE_SSN_CHECK',
    disableSSNCheck: 'DISABLE_SSN_CHECK',
    onUpdateCreditCheck: 'UPDATE_CREDITCHECK',
    onDueDateSuccess: 'ON_DUEDATE_SUCCESS',
    resetDueDate: 'RESET_DUEDATE',
    resetDueDateMsg: 'RESET_DUEDATE_MESSAGE',
    productChangedResetDueDate : 'PRODUCT_CHANGED_RESET_DUE_DATE',
    updateStorePickUpData: 'UPDATE_STOREPICKUP_DATA',
    updatePackageLockerData: 'UPDATE_PACKAGELOCKER_DATA',
    onUpdateCreditCheckStatus: 'UPDATE_CREDITCHECK_STATUS',
    isCreditCheckBannerStatus: 'UPADATE_CREDITCHECK_BANNER_STATUS',
    updatePersonalInfoAccordionStatus: 'UPDATE_PERSONALINFO_ACCOR_STATUS',
    updateSatelliteAccordionStatus: 'UPDATE_SATELLITE_ACCOR_STATUS',
    updateCreditCheckAccordionStatus: 'UPDATE_CREDITCHECK_ACCOR_STATUS',
    updateInstallationAccordionStatus: 'UPDATE_INSTALLATION_ACCOR_STATUS',
    updateDisconnectAccordionStatus: 'UPDATE_DISCONNECT_ACCOR_STATUS',
    updateAutoPayAccordionStatus: 'UPDATE_AUTOPAY_ACCOR_STATUS',
    updateReviewOrderAccordionStatus: 'UPDATE_REVIEW_ORDER_STATUS',
    updateTosAccordionStatus: 'UPDATE_TOS_ACCOR_STATUS',
    updateDepositAccordionStatus: 'UPDATE_DEPOSIT_ACCOR_STATUS',
    onSetDueDate: 'ON_SET_DUEDATE',  
    updateRTAQs:'UPDATE_RTA_Qs',
    updateRTAChoice:'UPDATE_CHOICE',
    updateRTAStatus:'UPDATE_RTA_STATUS',
    updateDepositInfo:'UPDATE_DEPOSIT_INFO',
    updateDepositAmount:'UPDATE_DEPOSIT_Amount',
    updateFinalBillStatus:'UPDATE_FINAL_BILL_STATUS',
    updateCRVNunmber:'UPDATE_CRV_NO',
    updateInitialState:'UPDATE_INITIAL_STATE',
    updateCreditFailAttempts:'UPDATE_CREDIT_FAIL_ATTEMPTS',
    updateFinalBillAttempts:'UPDATE_FINAL_BILL_ATTEMPTS',
    updateSameDayDelivery:'UPDATE_SAMEDAY_DELIVERY',
    updateSSNandDOBStatus:'UPDATE_SSN_DOB_STATUS',
    mobtnType:'Mobile',
    isOnLoadBillingAddressValidation: 'IS_ONLOAD_BILLING_ADDRESS_VALIDATION',
    satelliteEligible: 'SATELLITE_ELIGIBLE',
    satelliteOption:'SATELLITE_OPTION',
    satelliteClick:'SATELLITE_CLICK' ,
    updateBAUCC:'UPDATE_BAU_CC',
    PrevSelectedProd: 'PREV_SELECTED_PROD',
    checkoutLoaded:'CHECKOUT_LOADED',
    contactInfoValidationUpdate : 'CONTACT_INFO_VALIDATION_UPDATE',
    mvCheckout: 'MOVE_CHECKOUT',
    returnEquipmentOption: 'RETURN_ENQUIPMENT_OPTION',
    returnEquipmentClick: 'RETURN_ENQUIPMENT_CLICK',
    updateReturnEquipAccordianStatus: 'UPDATE_RETURN_ENQUIPMENT_ACCORDIAN_STATUS',
    fiabSelectedOption : 'FIAB_SELECTED_OPTION',
    updateDeliveryOptionAccordion:'UPDATE_DELIVERY_OPTION_STATUS',
    showDueMonthlyDetails:'SHOW_DUE_MONTHLY_DETAILS',
    updateFiosSupportMDN: 'UPDATE_FIOS_SUPPORT_MDN',
    homeSecurityChecked:'HOME_SECURITY_CHECKED',
    homeSecureChecked: 'HOME_SECURE_CHECK',
    homeSecurePlusChecked: 'HOME_SECURE_PLUS_CHECK',
}
export const Util = {
    onAutopay: 'AUTOPAY',
    onCreditCheck: 'CREDITCHECK',
    onDeposit: 'DEPOSIT',    
}
export const PFBAutopay = {
    onPFB: 'PFB',
    PFBChecked: 'PFBCHECKED',
    autopayChecked:'AUTOPAYCHECKED',
    pfbTosAgree:'PFBTOSAGREE',
    autopayTosAgree:'AUTOPAYTOSAGREE',
    autopayPFBTosAgree:'AUTOPAYPFBTOSAGREE',
    pfbUnCheckedContinue:'PFBUNCHECKEDCONTINUE',
    onPFBTosContinue: 'PFBCONTINUETOS',
    onValidatePFB: 'CO_VALIDATEPFB',
    onPFBClick: 'CO_PFB_Click',
    onupdateEmailID:'CO_UPDATE_EMAIL',
    onupdateFNameLName:'CO_FNAME_LNAME',
    onAutopay: 'AUTOPAY',
    onPaymentModeChange: 'CO_PAYMENTMODE_CHANGE',
    onCheckAutoPayOffer: 'CO_CHECK_AUTOPAYOFFER',
    onCreditPayment:'CO_CREDIT_PAYMENT',
    onValidateAutoPay: 'CO_VALIDATEAUTOPAY',
    onAutoPayContinueClick: 'CO_AUTOPAY_CONTINUE_CLICK',    
    onPaymentMode: {
        onSavings: 'SAVINGS',
        onChecking: 'CHECKING',
        onCredit: 'CREDIT',
        onDebit: 'DEBIT',
        onBank: 'BANK'
    },
    onPFBProfileVerified: 'onPFBProfileVerified',
    onCheckingSavingAC: 'CO_CHECKING_SAVING_AC',
    onCreditDebitAC: 'CO_CREDIT_DABIT_AC',
    onClearCard: 'CO_CLEARCARD',
    onVEPSCall: 'CO_VEPSCALL',    
    onAPIResponseCheck :{
        onSuccess:'success',
        onFailure:'fail'
    },
    onCBAChange: 'CBACHANGE',
    onValidateCBA: 'VALIDATECBA',    
    onCBASave: 'CBASAVE', 
    streetErr:'CBA_STREETERR',
    cityErr:'CBA_CITYERR',
    stateErr:'CBA_STATEERR',
    zipErr:'CBA_ZIPERR',
    onAutoPayReviewChange: 'AUTOPAYREVIEWCHANGE',
    onPFBAutoPayStatus:'AUTOPAYSTATUS',
    routingNumber:'routingNumber',
    accountNumber:'accountNumber',
    cardNumber:'cardNumber',
    bankAccountNumber:'bankAccountNumber',
    autoPayType: "AUTOPAY_TYPE",
    bankAccountType: "BANKACCOUNT_TYPE",
    isAutopayFormSaved: "AUTOPAY_FORM_SAVED",
    isShowPaymentAlertBanner: "SHOW_PAYMENTALERTBANNER",
    focusAlertBanner:"FOCUS_ALERTBANNER",
    enablePFBautoPayReskin: "ENABLE_AUTOPAYPFB_RESKIN",
    isVerizonVisaCC:"VERIZON_VISA_CC",
    isAutopayEligible:"AUTOPAY_ELIGIBLE"
}
export const PendingOrder = {
    pageLoad: 'PO_PAGE_LOAD',
    onYesClick: 'PO_YES_CLICKED',
    onNoClick: 'PO_NO_CLICKED',
    onBackClick: 'PO_BACK_CLICKED',
}

export const Summary = {
    orderPlaced:'ORDER_PLACED'
}
export const SmartSave = {
    pageLoad: 'SS_PAGE_LOAD',
    onContinueCart: 'SS_CONTINUECART',
    onNewOrder: 'SS_NEWORDER',
    onBackClick: 'SS_BACK_CLICKED',
}
export const MTNValidation = {
    updateVZWOfferEligibility:'UPDATE_VZWOFFER_ELIGIBILITY',
    updateVZWOfferEligibilityStatus:'UPDATE_VZWOFFER_ELIGIBILITY_STATUS',
    updateisAssessmentRequired:'UPDATE_ISREQ_ASSESSMENT',
    updateOTPSentStaus:'UPDATE_OTP_SENT_STATUS',
    updateOTPInfo:'UPDATE_OTP_INFO',
    updateVerifyOTP:'UPDATE_VERIFY_OTP',
    updateOTPAttempts:'UPDATE_OTP_ATTEMPTS',
    updateVZWOfferPageCallStatus:'UPDATE_VZWOFFER_ELIGIBILITY_PAGECALL_STATUS'

}
export const Contract = {
    twoYear: 'TWOYEAR',
    monthToMonth: 'MTM'
}

export const Pages =  {
    pegarecommendation: "./pegarecommendation",
    pegarecommendationSignin:"./signin?flowtype=af&source=urc&customerintent=ACCORDION&subflowtype=accordion&FirstVisit=&FlowRoute=&pegaMandM=y",
    CheckLQ: './qualification',
    CheckLQVTPVisitIdEmpty: './qualification?message=VTP_VisitIdEmpty',
    CheckLQ2dotO: './checkavailability',
    CheckOneLQ: './qualification?onelq=Y',
    CheckLQConn: './qualification?connflow=Y',
    MoveTestStartLocal: './moves/qualification?ismvflow=y&fromTestPage=Y',
    MoveTestStartLocalLQ: './moves/lq1qualification?ismvflow=y&fromTestPage=Y',
    GetMoveOrderDetail: './moves/getmoveorderdetail?lq2=Y',
    MoveTestStartLQ: './moves/checkavailability?ismvflow=y&fromTestPage=Y&skip5g=y',
    MoveTestStartWifiLQ: './moves/checkavailability?ismvflow=y&fromTestPage=Y&skip5g=y&agency=CETCORDER2',
    CheckLQVisitIdEmpty: './qualification?message=visitidempty',
    CheckLQ2VisitIdEmpty: './checkavailability?message=visitidempty',
    FutureNotification : './futureNotification',
    StreamLine: './streamlineordering',
    StreamLineTvVoice: './streamlinetvvoice',
    CheckAvail: '../foryourhome/ordering/checkavailabilitylq.aspx',
    CheckAvailPilot: 'https://orderinglite.verizon.com/foryourhome/ordering/checkavailabilitylq.aspx',
    CheckAvailPreProd: 'https://www.preprod.verizon.com/foryourhome/ordering/checkavailabilitylq.aspx',
    CheckAvailPreProdEast: 'https://preprod-east-gz.vpc.verizon.com/foryourhome/ordering/checkavailabilitylq.aspx',
    XpsEntry: '../foryourhome/ordering/ordernew/xpsentry.aspx',    
    GenerateCoupon: '../foryourhome/ordering/VzConnections/generateCoupon.aspx?/#/',
    SmartSave: './savecart',
    PendingOrder: './pendingorder',
    SignInMH: './signinmh',
    nonfiosRedirect: './nonfiosredirect',
    TwsDiscount: './twsdiscount',
    fifteng:'./15g',
    ECTwsDiscount: '../twsdiscount',
    SmartSaveEmail: './sendcart',
    fccBroadbandLabel:'./fccbroadbandlabels',
    fccLearnUrl:'https://www.verizon.com/content/wcms/broadband-facts/national.html',
    orderSummary: './ordersummary',
    Help: './help',
    ResumeCart:'./resumecart',
    BuildProduct: './buildproducts',
    BuildProductMidnight: './buildproducts',
    BuildProductMovesMidnight: './moves/buildproducts',
    BuildProductRskn: './buildproductsRskn',
    SignIn: './signin',
    ECSignIn: './change/signin',
    ECBuildProduct: './buildproducts',
    SigninCoupon: './employee',
    Checkout: './checkout',
    SubmitOrder: './summary',
    LBO: './lbo',
    lbohoa: './lbo-hoa',
    Nsinotification: './nsinotification',
    BAUNsinotification: '../foryourhome/ordering/ordernew/nsinotification.aspx',
    BAUNsiNYC: 'https://www.verizon.com/inhome/nsinotification.aspx',
    NsiLqrequest :'./nsirequest',
    Affinity:'./connection?flow=affinity',
    ProdMyVzAccount:'https://www.verizon.com/consumer/myverizon/router?Target=null',
    NonProdMyVzAccount:'https://sso-np.ebiz.verizon.com/consumer/myverizon/router?Target=null',
    ProdCheckOrderStatus:'https://www.verizon.com/consumer/myverizon/router?src=NEWORDER',
    NonProdCheckOrderStatus:'https://www98.verizon.com/consumer/myverizon/router?src=NEWORDER',
    MyVz:'/home/myverizon/',
    //VzHome:'/?lid=//global//residential ',
    VzHome:'/home/fios-fastest-internet/',
    Employee:'./connection?flow=employee',
    EmployeeConfirmation:'./connection?confirmation',
    EnterpriseID:'./connection?enterpriseid',
    FaxProof:'./connection?faxproof',
    UploadProof:'./connection?uploadproof',
    MyOrderInfo:'/orderinfo/welcomebasket?useroption=N&mon=',
    Registrationbridge:'../foryourhome/ordering/myverizonnew/registrationbridge.aspx',
    RegistrationbridgeEC:'/foryourhome/ordering/myverizonnew/registrationbridge.aspx',
    bau:'/foryourhome/ordering/myverizonnew/registrationbridge.aspx?URCSource=ATOM',
    ECValidateSignIn:'change/signin?flowtype=af&source=urc&customerintent=ACCORDION&subflowtype=accordion&FirstVisit=&FlowRoute=',
    ECValidateSiginInInsider:'signin?flowtype=af&source=urc&customerintent=ACCORDION&subflowtype=accordion&FirstVisit=&FlowRoute=',
    PegaToECBuildProduct:'../signin?flowtype=af&source=PegaNoThanksLink&customerintent=ACCORDION&subflowtype=accordion&FirstVisit=&FlowRoute=',
    PegaToECBuildProductRedirect:'./signin?flowtype=af&source=PegaNoThanksLink&customerintent=ACCORDION&subflowtype=accordion&FirstVisit=&FlowRoute=',
    EcMfrt:'change/signin?flowtype=af&source=twsdiscount&customerintent=ACCORDION&subflowtype=accordion&FirstVisit=&FlowRoute=',
    // Oof:'../home/OrderNew/OutOfFranchise.html?MO=Y',
    Oof:'http://www.movearoo.com/verizon/out-of-area?kbid=56643',
    conflictMessage:'./connection?conflictmessage',
    AssociationError:'./connection?flow=associationerror',
    Wireless5G: 'https://www.verizonwireless.com/5g/home/?fromfios=Y',
    AccountAccess:'./accountaccess',
    tvRecommendation: './tvrecommender',
    disconnectCheckout: './disconnect',
    renewalBundlePlans: './pega/renewalBundlePlans',
    bundlePlans: './renewalBundlePlans',
    bundleDetails: './bundleDetails',
    installation: './installation',
    review: './review',
    confirmation: './confirmation',
    recommendationPlan: './recommendation/plan',
    recommendPlan: './plan',
    recommendationDetail: './detail',
    recommendationPremiumChannel: './premiumchannel',
    recommendationReviewOrder: './order',
    recommendationSwitchPkg: './switchpackage',
    affinityConfirmation: './connection?empConfirmation',
    recommendationSummary: './recommendation/orderSummary',
    routerUpgradeConfirm: './routerConfirmation?confirmed',
    routerDeclined: './routerConfirmation?declined',
    LegacyToVMSConfirmation: './LegacyToVMSConfirmation',
    //move Change
    moveLanding:'./landing',
    MyVzSigninAF:'https://ssoauth.verizon.com/vzauth/UI/Login?realm=vzw&service=WlnOneVerizonChain&sourceDomain=https://www.verizon.com&remainInOverlay=N&modeAfterSubmit=o&fromVZT=Y&userNameOnly=false&clientId=VZCOMBQ&goto=https%3A%2F%2Fwww.verizon.com%2Fconsumer%2Fmyverizon%2Frouter%3Ftarget%3Dhttps%253A%252F%252Fwww.verizon.com%252Fforyourhome%252Fordering%252Fmyverizonnew%252Fregistrationbridge.aspx',
    MyVzSigninAFNew:'https://secure.verizon.com/signin?userNameOnly=true&clientId=VZCOMBQ&goto=https%3A%2F%2Fwww.verizon.com%2Fconsumer%2Fmyverizon%2Frouter%3Ftarget%3Dhttps%253A%252F%252Fwww.verizon.com%252Fforyourhome%252Fordering%252Fmyverizonnew%252Fregistrationbridge.aspx',
    MyVzSigninMV:'https://sit-ssoauth.verizon.com/vzauth/UI/Login?realm=vzw&service=WlnOneVerizonChain&sourceDomain=https://wwwawssit.ebiz.verizon.com&remainInOverlay=N&mode=i&modeAfterSubmit=o&fromVZT=Y&userNameOnly=false&clientId=VZCOMBQ&goto=https%3a%2f%2fsit-ssoauth.verizon.com%2fsso%2fProcessLoginServlet%3floginType%3dconsumer%26target%3dhttps%253a%252f%252fwwwawssit.ebiz.verizon.com%252fforyourhome%252fmyaccount%252fngen%252fpr%252fcommon%252fergcon.aspx%253ftarget%253dhttps%25253a%25252f%25252fwwwawssit.ebiz.verizon.com%25252finhome%25252fqualification%25253fismvflow%25253dy',
    MyVzSigninMVNew:'https://secure.verizon.com/signin?userNameOnly=true&clientId=VZCOMBQ&goto=https%3A%2F%2Fwww.verizon.com%2Fconsumer%2Fmyverizon%2Frouter%3Fsrc%3DRAPPOS%26target%3Dhttps%253a%252f%252fwww.verizon.com%252finhome%2Fmoves%252fqualification%253fismvflow%253dy',
    MovesCheckLQ: './move/qualification',
    MoveSignIn: './movesignin',
    MyVerizonSignInMv: 'https://www.verizon.com/consumer/myverizon/router?target=https://www.verizon.com/inhome/moves/qualification?ISMVFLOW=Y&Source=INHOME',
    MovesPostSignIn: '/inhome/moves/qualification?ismvflow=y',
    accessories: 'https://www.verizon.com/home/accessories/',
    CheckAvailFromMoves: '/foryourhome/ordering/checkavailability.aspx',
    MyVzDashboard:'../../../foryourhome/myaccount/pr/dashboard/details',
    internetOverView: '/home/',
    // MoveTestStart: './move/qualification?ismvflow=y&fromTestPage=Y',
    suspendservices:"./suspendservices",
    restoreservices:"./restoreservices",
    pegaPremiumChannels:'./pegaPremiumChannels',
    businessType: "/foryoursmallbiz/so/ordernew/qualify/lqfullpageentry",
    spanishFiosURLPROD: "https://espanol.verizon.com/inhome/fiosreferral",
    spanishfiosURLStage: "https://espanolstage.verizon.com/inhome/fiosreferral",
    fiosURLStage: "https://www98.verizon.com/inhome/fiosreferral",
    fiosURLPROD: "https://www.verizon.com/inhome/fiosreferral",
    popularPlan: './popularPlans',
}
export const ModalWindow = {
    onModalWindowOpen: 'OPEN_MODAL',
    onModalWindowClose: 'CLOSE_MODAL',
    onCartModalWindowOpen: 'CART_MODAL_OPEN',
    onCartModalWindowClose: 'CART_MODAL_CLOSE',
    ids: {
        currentCart: 'CURRENT_CART',
        yourCart: 'YOUR_CART',
        viewDetail: 'DETAIL',
        faq: 'FAQ',
        comparePrice: 'COMPAREPRICE',
        seeBillDetails: 'SEEBILLDETAILS',
        savingsDetails: 'SAVINGSDETAILS',
        autoPayDetails:'AUTOPAYDETAILS',
        faq_Mob: 'FAQ_MOBILE',
        callMeNow: 'CALLME',
        callMeNow_Mob: 'CALLME_MOBILE',
        techSureHelp: 'HELPTECHSURE',
        compareVasip: 'COMPAREVASIP',
        fneHelp:'HELPFNE',
        routerHelp:'HELPROUTER',
        dataHelp: 'HELPDATA',
        batteryHelp:'HELPBATTERY',
        discoveryDiscalimer : 'DISCOVERY',
        connectedAppsVroom : 'CEVROOM',
        connectedAppsTVConnections : 'CETVCONNECTIONS',
        connectedAppsCEApps : 'CECEAPPS',
        connectedAppsConfirm : 'CECEAPPSCONFIRM',
        listingHelp:'HELPLISTING',
        customTvHelp:'HELPCUSTOMTV',
        tvHelp:'HELPTV',
        dctHelp:'HELPDCT',
        banner: 'BANNER',
        footerLearn: 'FOOTER_LEARN',
        additionalSavings: 'ADDITIONAL_SAVINGS',
        jmp: 'JMP',
        winBackYes: 'WINBACKYES',
        winBackNo: 'WINBACKNO',
        fiosFive: 'FIOSFIVE',
        firstBill: 'SOC',
        storeLocations: 'STORE_LOCATIONS',
        tos: 'TOS',
        tosview: 'TOSCHECKBOX',
        promo: 'PROMO',
        PFBContinueTos: 'PFBCONTINUETOS',
        cba: 'CBA',
        AUTOPAYContinueTos:'AUTOPAYCONTINUETOS',
        AUTOPAYPFBTos:'AUTOPAYPFBTos',
        customRouter:'OWNROUTER',
        coupon:'COUPON',
        save:'SAVE',
        saveEc:'SAVE_EC',
        saveTargetDeposit:'SAVETARGETDEPOSIT',
        save_Mob:'SAVE_MOBILE',
        notification:'FUTURENOTIFICATION',
        smTNCheck:'SM_TNCHECK',
        autopayToggle:"AUTOPAYTOGGLE",
        paperfreeBillingToggle: "PAPERFREEBILLINGTOGGLE",
        autopayVZCCModal: "AUTOPAYVZCCMODAL",
        smMakeChange:'SM_MAKECHANGE',
        smExistingCart:'SM_EXISTINGCART',
        uploadProof:'UPLOADPROOF',
        helpEquip:'HELPEQUIPMENT',
        refundDeposit:'REFUNDDEPOSIT',
        shpadrConf: 'SHIPADR_CONFIRM',
        tosSignIn:'TOSSIGNIN',
        worryFree:'WORRYFREE',
        ccvPayment:'CCV_PAYMENT',
        upsell:'UPSELL',
        ultimateTestDrive:'ULTIMATE_TEST_DRIVE',
        multiGigDataFios:'MULTI_GIG_FIOS',
        addpremium:'ADDPREMIUMHELPER',
        routerSeeDetails:'ROUTERSEEDETAILS',
        bhrxRouterDetails:'BHRXROUTERDETAILS',
        unSupportedDetails:'unSupportedDetails',
        seeDetail:'SEEDETAIL',
        upsellCart:"UPSELL_CART",
        fiosWFG: 'WORRYFREE',
        smCheck : 'SM-CHECK',
        suppCurrentCart:'SUPP_CURRENTCART',
        voiceDisconnect: 'VOICE_DISCONNECT',
        addlIntrPkg:'ADDLINTRPKG',        
        connectedtvInterestOverlay: 'INTERESTOVERLAY',
        internationalCallingOverlay: 'INTLCALLINGOVERLAY',
        internationalPlanOverlay: 'INTLPLANOVERLAY',
        wifiExtender: 'WIFIEXTENDER',
        videoComparisonConfirmation: 'VIDEOCOMPARISON',
        bussinessRedirect:'BUSSINESSREDIRECT',
        mnhQualified:'MNHQUALIFIED' ,
        multiGigOverlay: 'MULTIGIG',
        tvVoiceHelpMultigig:"TVVOICEHELPMULTIGIG",
        SimpliSafe4PieceBundle:"DETAIL_R1519",
        SimpliSafe8PieceBundle:"DETAIL_R1518",
        mm3PlansAvailable: "MM3_PLANS_AVAILABLE_OVERLAY",
        SetupfeeWaiver: 'SETUPFEE_WAIVER',
        vzfwdClassicDetails: "VZFWD_CLASSIC_DEATILS",
        URCPerksOverlay: 'URCPerksOverlay'
    }
}
export const Service = {
    internet: 'INTERNET',
    router:  WIFI7 ? 'AccessPoint' : 'ROUTER',
    accessPoint: 'AccessPoint',
    mm3subprod : 'MM3INTERNETSUBPROD',
    customRouter:"CUSTOMROUTER",
    techSure: 'TECHSURE',
    dhsBiller:'DHSBILLER',
    cloud: 'CLOUD',
    perks: 'PERKS',
    vas: 'PPP',
    fne: 'FNE',
    tv: 'TV',
    discoveryDiscalimer : 'DISCOVERY',
    voice: 'FIOS_VOICE',
    hsi: 'HSI',
    vRoom: 'VROOM',
    recording: 'RECORDING',
    listing: 'LISTING',
    battery: 'BATTERY',
    batteryshipment: 'BBUSHIPMENT',
    channel: 'CHANNEL',
    additionalChannel: 'ADDITIONALCHANNEL',
    intrnlChnlPlan:'INTERNATIONALCHANNELPLAN',
    intrnlChnl:'INTERNATIONALCHANNEL',
    internationalPackage:'INTLPREMIUM',
    internationalPackageCart:'INTLPACKAGE',
    winBack: 'WINBACK',
    customTV: 'CUSTOMTV',
    winBackNo: 'WINBACKNO',
    data: 'DATA',
    video: 'VIDEO',
    dct:'DCT',
    dctHelp:'HELPDCT',
    FiOSData:'FIOSDATA',
    FiOSVoice:'VOICE',
    customGeneric: 'CUSTOM_GENERIC',
    splOffer:'SPLOFFER',
    flashOffer:'FLASHOFFER',
    streamServ:'OTTBASIC',
    streamDev:'OTTEQUIPNRC',
    streamDevCount:'STREAMDEVCNT',
    streamDevCountResume:'STREAMDEVCNTRESUME',
    youtubeReferal:'YOUTUBE_REFERAL',
    youtube:'YOUTUBE',
    ultimatetestdrive : 'ULTIMATETESTDRIVE',
    fiosfive : 'Fios_Five',
    prefer : 'PREFERRED',
    ultimate : 'ULTIMATE',
    slingtv:'SLING_REFERAL',
    fiosFive:'FIOSFIVE',
    mundo:"MUNDO",
    local_tv:"LOCLDGTL",
    vasstandalone: 'VASSTANDALONE',
    fiosTvOne: 'fiosTvOne',
    vms1100:'vms1100',
    fneDeviceCount: 'fneDeviceCount',
    callingFeature: 'CALLINGFEATURE',
    intlPlans: 'INTLPLAN',
    longDistance: 'LONGDISTANCE',
    wireMaintenance: 'WIREMAINTENANCE',
    vasService: 'VAS',
    premium: 'PREMIUM',
    ceAppsParity: 'CEDEVICEAPP',
    ceAppsBundle: 'CEDEVICEAPPBNDL',
    dummyvRoom: 'DUMMYVROOM',
    equipment: 'Equipment',
    setupbox: 'SETUPBOX',
    mrdvr: 'EM-DVR',
    whw:'WHW',
    whwFaq:'WHWFAQ',
    mm3:'MM3',
    emergencyServices: 'emergencyServices',
    vhsBiller:'VHSBILLER'
}

export const ServiceTaggingDetail = {
    INTERNET: 'Internet',
    ROUTER: 'Please select Router',
    SPLOFFER: 'Choose your offer',
    PERKS: 'Perks',
    RECORDING: 'Add your recording service',
    PREMIUM: 'Premium channels',
    CHANNEL: 'Premium channels',
    INTERNATIONALCHANNEL: 'Add international channels',
    FIOS_VOICE: 'Add phone',
    INTLPLAN: 'Call more international places',
    WINBACK: 'Add your phone number',
    LISTING: 'Add to directory listing',
    BATTERY: 'Add powerReserve',
    TECHSURE: 'Add Internet Security, Protection and More',
    LIVETV: 'Add Live tv',
    SPANISHTV: 'Spanish',
    BBUSHIPMENT: 'Shipping Service',
    VROOM: 'tv customize',
    CUSTOMTV:'tv customize',
    OTTEQUIPNRC: 'Use-your-own streaming device',
    STREAMDEVCNT:'Use-your-own streaming device',
    DUMMYVROOM:'tv customize',
    CEDEVICEAPPBNDL:'Use-your-own streaming device',
    emergencyServices: 'Emergency Services',
}

export const EquipmentProductTypes = {
    vFeature: 'VFEATURE',
    movie: 'MOVIE',
    ott: 'OTT',
    routerBiller: 'ROUTERBILLER',
    routerNrcBiller: 'ROUTERNRCBILLER',
    networkExtenderNrc: 'NETWORKEXTENDERNRC',
    networkExtenderMrc: 'NETWORKEXTENDERMRC',
    slaBattery: 'SLABATTERY',
    FVINTLPLAN: 'FVINTLPLAN',
    FVNONPUB: 'FVNONPUB',
    FVLISTMAIN: 'FVLISTMAIN',
    DCELL: 'DCELL',
    FVMAIL: 'FVMAIL',
    OTTBASIC: 'OTTBASIC',
    VROOM: 'VROOM',
    BATTERY: 'DCELLTRAY',
    VALUEADD: 'VALUEADD' 
}

export const EquipmentDiscounts = {
    router: 'FCP_ROUTER_BHRx_DISCOUNT',
    vRoom: 'FCP_STB_DISCOUNT',
    recording: 'FCP_RECFEATURE_DISCOUNT',
    routerEmp: 'FCPEMPL_ROUTER_BHRx_DISCOUNT',
    recordingEmp: 'FCPEMPL_RECFEATURE_DISCOUNT',
    recordingEmpMM2: 'MnM2.0_RECFEATURE_DISCOUNT',
    vRoomEmp: 'FCPEMPL_STB_DISCOUNT',
    whw:'100%'
}
export const ProductType = {
    INTERNET_PLAN: 'FTTPD',
    TV_BASIC: 'BASIC',
    TV_BASICDIFF: 'BASICDIFF',
    VOICE_PRIMARY: 'FVPRIMARY',
    VAS_PLAN: 'PPP',
    PERKS_PLAN: 'BYOPERK'
}
export const AccordionStatus = {
    added: 'added',
    required: 'required',
    completed: 'completed',
    actionRequired: 'action required',
    reviewRequired: 'review required',
    optional: 'optional'
}
export const CartServices = {
    service: 'Service',
    Service: 'service',
    RemovedService: 'Removed Services',    
    dataStandalone: 'DATASTANDALONE',
    tvStandalone: 'TVSTANDALONE',
    voiceStandalone: 'VOICESTANDALONE',
    bundle: 'SVCCOMPONENT',
    equipment: 'Equipment',    
    removedequipment: 'Removed Equipment',
    removedperks: 'Removed Perks',
    oneTimeCharges: 'Onetimecharges',
    internet: 'VASSTANDALONE',
    channel: 'CHANNEL',
    intrnlChnl:'INTERNATIONALCHANNEL',
    intrnlChannel:'INTLPACKAGE',
    listing: 'LISTING',
    Promotions:'Promotions',
    Offers:'Offers',
    dataPlans:'dataplans',
    tvPlans:'tvPlans',
    voicePlans:'voicedetails',
    streamService:'STREAMINGSERVICES',
    streamDevice:'Streaming Devices',
    specialoffer:'SpecialOffers',
    channelsNotInPack: 'CHANNELSNOTINPACK',
    returnedequipment: 'Returned products Equipment',
    removedStreamServices: 'Removed Streaming Services',
    otherChannel: 'OTHERCHANNEL',
    Perks: 'Perks'
}
export const CartServicesEsponal = {
    service:'Servicio',
    Promotions:'Promociones',
    equipment:'Equipo',
    oneTimeCharges: 'Cargos únicos',
    Offers:'Ofertas',

    dataStandalone: 'DATASTANDALONE',
    tvStandalone: 'TVSTANDALONE',
    voiceStandalone: 'VOICESTANDALONE',
    bundle: 'SVCCOMPONENT',        
    removedequipment: 'Removed Equipment',    
    internet: 'VASSTANDALONE',
    channel: 'CHANNEL',
    intrnlChnl:'INTERNATIONALCHANNEL',
    listing: 'LISTING',
    
    dataPlans:'dataplans',
    tvPlans:'tvPlans',
    voicePlans:'voicedetails',
    streamService:'STREAMINGSERVICES',
    streamDevice:'Streaming Devices',
    specialoffer:'SpecialOffers',
    channelsNotInPack: 'CHANNELSNOTINPACK'
}

export const CartActions = {
    toggleCart: 'TOGGLE_CART',
    toggleYourCart:'TOGGLE_YOUR_CART',
    toggleOffers: 'TOGGLE_OFFERS',
    splitBillTab: 'SPLITBILL_TAB',
    clearcartstate: 'CLEARCARTSTATE',
    toggleToolTip:'TOGGLE_TOOLTIP',
    fiosSetupFee:'FIOSSETUPFEE',
    toggleProfileCart: 'TOGGLE_PROFILE_CART',
    clearCartState: 'CLEARCARTSTATE'

}

export const ContractConstants = {
    all: 'ALL',
    twoYear: '2YR',
    monthToMonth: 'MTM',
    accordionTwoYearTitle: "2-year agreement",
    accordionMonthToMonthTitle: "No annual contract",
    retainAgreement: "Retain agreement",
    twoYearInWords: "TWOYEAR",
    contractChange: "CONTRACTCHANGE"
}

export const InstallationConstants = {
    key: 'INSTALLATIONTYPE',
    techInstall: 'TECHINSTALL',
    selfInstall: 'SELFINSTALL',
}

export const LocationIds = {
    internetHeader: '278',
    RouterHeader:'279',
    tvHeader:'280',
    customTvPacksHeader: '281',
    channelHeader:'282',
    channelPricingText:'283',
    priceText:'284',
    tvEquipmentHeader: '285',
    equipmentPrice:'286',
    fdvHeader:'288',
    lobHeader:'289',
    bbuShippingHeader: '290',
    equipmentHeader:'325',
    contractText:'100',
    streamingDevicesText:'326',
    streamingCartAbove:'327',
    streamingCartBelow:'328',
    streamingDevicesHeader:'329',
    setTopBoxHeader: '330',
    dvrHeader: '331',
    ceAppsHeader: '332',
    tvConnectionsHeader: '333'
}


export const BannerTypes = {
    default: 'default',
    vdsl:'vdsl',
    nonFTV:'nonFTV',
    move: 'move',
    moves_buildProduct: 'moves_buildProduct',
    Employee: 'Employee',
    ResumeCart: 'ResumeCart',
    connections: 'connections',
    JDOffer:'JDOffer',
    Flash: 'BlackFriday',
    BlackFriday2020: 'BlackFriday2020',
    Supp:'Supp',
    VecOrder:'VecOrder',
    moves_MoversGigOffer:'moves_MoversGigOffer',
    moves_MoversNonGigOffer:'moves_MoversNonGigOffer',
    PreholidayOffersGig:'PreholidayOffersGig',
    PreholidayOffersNonGig:'PreholidayOffersNonGig',
    PreholidayOffersSOCNOCGig:'PreholidayOffersSOCNOCGig',
    PreholidayOffersSOCNOCNonGig:'PreholidayOffersSOCNOCNonGig',
    PreholidayOffersGigClassic:'PreholidayOffersGigClassic',
    PreholidayOffersNonGigClassic:'PreholidayOffersNonGigClassic',
    PreholidayOffersSOCNOCGigClassic:'PreholidayOffersSOCNOCGigClassic',
    PreholidayOffersSOCNOCNonGigClassic:'PreholidayOffersSOCNOCNonGigClassic',
    samsungOffersGig:'samsungOffersGig',
    samsungOffersNonGig:'samsungOffersNonGig',
    samsungOffersSOCNOCGig:'samsungOffersSOCNOCGig',
    samsungOffersSOCNOCNonGig:'samsungOffersSOCNOCNonGig',
    samsungOffersGigClassic:'samsungOffersGigClassic',
    samsungOffersNonGigClassic:'samsungOffersNonGigClassic',
    samsungOffersSOCNOCGigClassic:'samsungOffersSOCNOCGigClassic',
    samsungOffersSOCNOCNonGigClassic:'samsungOffersSOCNOCNonGigClassic',
    vintageOffer:'vintageOffer',
    BlackFriday2021Gig : 'BlackFriday2021Gig',
    BlackFriday2021IONTGig : 'BlackFriday2021IONTGig',
    BlackFriday2021NonGig : 'BlackFriday2021NonGig',
    BlackFriday2021IONTNonGig : 'BlackFriday2021IONTNonGig',
    Holiday2021Gig : 'Holiday2021Gig',
    Holiday2021IONTGig : 'Holiday2021IONTGig',
    Holiday2021NonGig : 'Holiday2021NonGig',
    Holiday2021IONTNonGig : 'Holiday2021IONTNonGig',
    DisneyBundleGig : 'DisneyBundleGig',
    DisneyBundleIONTGig : 'DisneyBundleIONTGig',
    DisneyBundleNonGig : 'DisneyBundleNonGig',
    DisneyBundleIONTNonGig : 'DisneyBundleIONTNonGig',
    DisneyBundleIONTGig200: 'DisneyBundleIONTGig200',
    DisneyBundleIONTNonGig200: 'DisneyBundleIONTNonGig200',
    SWAT2021GigLoyaltyWaiver : 'SWAT2021GigLoyaltyWaiver',
    SWAT2021GigLoyalty : 'SWAT2021GigLoyalty',
    FastStartLeadlist1:'FastStartLeadlist1',
    FastStartLeadlist2:'FastStartLeadlist2',
    SimpliSafe8PieceBundle : 'SimpliSafe8PieceBundle',
    SimpliSafe8PieceBundleSOCNOCGIG : 'SimpliSafe8PieceBundleSOCNOCGIG',
    SimpliSafe8PieceBundleNONGIG : 'SimpliSafe8PieceBundleNONGIG',
    SimpliSafe8PieceBundleSOCNOCNONGIG : 'SimpliSafe8PieceBundleSOCNOCNONGIG'
}

export const OfferTypes = {
    SimpliMover8:'SIMPLISAFE_8_PIECE_BUNDLE',
    jointDeviceOffer:'JMPADD',
    Reward:'VZREWARD',
    // SimpliSafeBundle:'MnM_$200CARD_DISCOUNT',
    SpecialDiscount:'SPCLDISCOUNT',
    jointDevice:'FIOS200',
    disney200:'$200_HOLIDAY_VISACARD',
    Flash:'SAMSUNG_GALAXY_BUDS',
    Flash_$100:'$100_VZ_GIFT_CARD_BF',
    Flash_Sony:'SONY_PLAYSTATION',
    Flash_GoogleNest : 'NEST_HUBMAX_DATA_BF',
    Flash_GoogleNestAudio : 'NEST_AUDIO_DATA',
    Flash_$200GC:'$200_VERIZON_GC_DISCOUNT_BF',
    GoogleStadia:'GOOGLESTADIA_3MO',
    Card100:'FCP_$100CARD_DISCOUNT',
    Card200:'FCP_$200CARD_DISCOUNT_GPONiONT',
    VerizonGiftCard:'MnM_$100CARD_DISCOUNT',
    NewOccupant:'FCP_$150CARD_DISCOUNT_GPONiONT',
    Hulu:'HULUSVOD_12MO',
    Hulu6Mo:'HULUSVOD_6MO',
    Disney:'DISNEYPLUS_12MO',
    Disney2:'DISNEYPLUS_6MO',
    GoogleNestHubMax: 'NEST_HUBMAX_DATA',
    disneyBundle: 'DISNEYBUNDLE_12MO',
    disneyBundle6Mo: 'DISNEYBUNDLE_6MO',
    Grubhub:'GRUBHUB_3DELFREE',
    OneMonthInt:'OneMonth_Internet_disc',
    VerizonGC100NMDA: '$100_VERIZON_GC_DISCOUNT_NDMA',
    VerizonGC200NMDA: '$200_VERIZON_GC_DISCOUNT_NDMA',
    VIXPREMIUM_12MO: 'VIXPREMIUM_12MO',
    FIOS_XBOX_SERIES_S_ACQ_CM2024: 'FIOS_XBOX_SERIES_S_ACQ_CM2024',
    FIOS_XBOX_BUNDLE_HEADSET_CONTROLLER_CM24 : 'FIOS_XBOX_BUNDLE_HEADSET_CONTROLLER_CM24',
    FIOS_META_QUEST_3S_HEADSET_Q125_PROMO : 'FIOS_META_QUEST_3S_HEADSET_Q125_PROMO',
    FIOS_SAMSUNGTV_Q125_PROMO : 'FIOS_SAMSUNGTV_Q125_PROMO',
    FIOS_SAMSUNGTECHCREDITONUS_BESTBUY: 'FIOS_SAMSUNGTECHCREDITONUS_BESTBUY',
    FIOS_RAYBAN_META_GLASSES: 'FIOS_RAYBAN_META_GLASSES',
    FIOS_LOCALJBLPARTYBOX_Q225_PROMO: 'FIOS_LOCALJBLPARTYBOX_Q225_PROMO',
    VerizonGC100: '$100_VERIZON_GC_DISCOUNT',
    Verizon150GC:'$150_VERIZON_GC_DISCOUNT',
    VerizonGC200: '$200_VERIZON_GC_DISCOUNT',
    Spcl20Incentive :'Special_$20_Discount',
    Spcl10Incentive:'$10',
    Spcl15Incentive:'$15',
    Spcl25Incentive:'$25',
    OneMonthonus:'OneMonth_Internet_disc',
    youtubePremium:'YOUTUBEPREMIUM_PERK_DISCOUNT',
    //IMPORTANT: Format is <OFFER_ATTRIBUTE_VALUE>_<OFFER_ATTRIBUTE> for allManualOFfers,ExclusionOFfers,
    allManualOFfers:{DATA:'FIOS_SAMSUNGTECHCREDITONUS_BESTBUY_SPCLDISCOUNT|FIOS_RAYBAN_META_GLASSES_SPCLDISCOUNT|FIOS_LOCALJBLPARTYBOX_Q225_PROMO_SPCLDISCOUNT|FIOS_META_QUEST_3S_HEADSET_Q125_PROMO_SPCLDISCOUNT|FIOS_SAMSUNGTV_Q125_PROMO_SPCLDISCOUNT|FIOS_XBOX_SERIES_S_ACQ_CM2024_ACQCYBERMONDAY2024|FIOS_XBOX_SERIES_S_ACQ_BF2024_ACQBLACKFRIDAY2024|FIOS_XBOX_BUNDLE_HEADSET_CONTROLLER_CM24_ACQCYBERMONDAY2024|FIOS_XBOX_BUNDLE_HEADSET_CONTROLLER_VZREWARD|Special_$20_Discount_SPCLDISCOUNT|$10_SPCLDISCOUNT|DISNEY_BUNDLE_PERK_DISCOUNT_SPCLDISCOUNT|FIOS_XBOX_BUNDLE_HEADSET_CONTROLLER_VZREWARD|Special_Ongoing_$5_Discount_SPCLDISCOUNT|Special_Ongoing_$20_Discount_SPCLDISCOUNT|SPR_VIN_NYDMA_SPCLDISCOUNT|SONYPULSE3D_WLS_HEADSET_ACQ_VZREWARD|SONY_PS5_ACQ_VZREWARD|SONYPULSE3D_WLS_HEADSET_ACQ_HS_VZREWARD|FCP_$150CARD_DISCOUNT_GPONiONT_VZREWARD|AMAZON_SHOW5_RING_SPCLDISCOUNT|AMAZON_SHOW5_SPCLDISCOUNT|AMAZON_ECHODOT_SMARTPLUG_SPCLDISCOUNT|MARVEL_AVENGERS_SPCLDISCOUNT|$100CARD_DISCOUNT_VZREWARD|$100_VERIZON_GIFT_CARD_DISCOUNT_VZREWARD|$50_VERIZON_GIFT_CARD_DISCOUNT_VZREWARD|$100_VERIZON_GIFT_CARD_VZREWARD|$50_VERIZON_GIFT_CARD_VZREWARD|SONY_PLAYSTATION_ACQBLACKFRIDAY2020|SONY_PLAYSTATION_3MONTH_SPCLDISCOUNT|AMAZON_ECHODOT_BLINK_SPCLDISCOUNT|AMAZON_ECHOSPEAKER_RING_SPCLDISCOUNT|AMAZON_PRIME_12MO_SPCLDISCOUNT|SAMSUNG_CHROME_SPCLDISCOUNT|SAMSUNG_TAB_A7_LITE_SPCLDISCOUNT|SPR_VIN_PH_BO_DMA_SPCLDISCOUNT|SAMSUNG_CHROME_100_SPCLDISCOUNT|SAMSUNG_TAB_A7_LITE_50_SPCLDISCOUNT|$100_VERIZON_EGIFT_CARD_DISCOUNT_VZREWARD|$50_VERIZON_EGIFT_CARD_DISCOUNT_VZREWARD|NEST_HUBMAX_DATA_BF_ACQBLACKFRIDAY2021|SPR_VIN_NOT_NYDMA_SPCLDISCOUNT|SIMPLISAFE_4_PIECE_BUNDLE_SPCLDISCOUNT|SIMPLISAFE_8_PIECE_BUNDLE_SPCLDISCOUNT|HD_WI-FI_SECURITY_CAMERA_SPCLDISCOUNT|STREAM_TV_ACQ_VZREWARD|STREAM_TV_SOUNDBAR_ACQ_399_VZREWARD|STREAM_TV_ACQ_VZREWARD|STREAM_TV_SOUNDBAR_ACQ_400_VZREWARD|STREAM_TV_SOUNDBAR_ACQ_250_VZREWARD|STREAMTVSOUNDBAR_ACQ_100_VZREWARD|Special_Ongoing_$20_Discount_SPCLDISCOUNT|AMAZONECHOSHOW10_ACQ_VZREWARD|AMAZONECHOSHOW5_ACQ_VZREWARD|AMAZON_ECHO_DOT_VZREWARD|$200_GRUBHUB_DOORDASH_GC_VZREWARD|$100_GRUBHUB_DOORDASH_GC_VZREWARD|$50_GRUBHUB_DOORDASH_GC_VZREWARD|$100_WALMART_GC_DISCOUNT_VZREWARD|$50_WALMART_GC_DISCOUNT_VZREWARD|FIOS_XBOX_SERIES_S_CONSOLE_VZREWARD|FIOS_XBOX_CONTROLLER_ELITE_II_VZREWARD|FIOS_XBOX_STEREO_HEADSET_VZREWARD|$300_THE_HOME_DEPOT_GC_VZREWARD|$200_THE_HOME_DEPOT_GC_VZREWARD|$50_THE_HOME_DEPOT_GC_VZREWARD|STREAM_TV_SOUNDBAR_ON_US_ACQ_VZREWARD|STREAM_TV_SOUNDBAR_PRO_ACQ_VZREWARD|STREAM_TV_ON_US_ACQ_VZREWARD|FIOS_CHROMEBKGO_SPCLDISCOUNT|FIOS_NFLSUNTK_SPCLDISCOUNT|FIOS_CHROMEBKGO_BUDS_SPCLDISCOUNT|FIOS_CHROMEBKGO100SAMS_BUDS_SPCLDISCOUNT|FIOS_CHROMEBKGO100SAMS_SPCLDISCOUNT|FIOS_HOMEPOD_SPCLDISCOUNT|FIOS_HOLIDAY_ECHOSHOW10_SPCLDISCOUNT|FIOS_AMAZON_200_GC_VZREWARD|FIOS_AMAZON_100_GC_VZREWARD|FIOS_XBOX_SERIES_S_ACQ_BF2023_ACQBLACKFRIDAY2023|FIOS_TARGET_200_GC_VZREWARD|FIOS_TARGET_100_GC_VZREWARD|FIOS_CHROMEBKGO_SWAT_SPCLDISCOUNT|FIOS_TARGET_300_GC_VZREWARD|FIOS_SAMSUNGAPPLICANCE_HOMEDEPOT_SPCLDISCOUNT|FIOS_RAYBAN_META_SMART_GLASSES_SPCLDISCOUNT|FIOS_LOCALJBLPARTYBOX_SPCLDISCOUNT',VIDEO:''},
    allMNHOffers: 'ADVBSMRKT1,ADVBSMRKT2,ADVBSMRKT3,ADVWSMRKT1,ADVWSMRKT2,ADVWSMRKT3,ADVBSOFRT1,ADVBSOFRT2,ADVBSOFRT3,ADVWSOFRT1,ADVWSOFRT2,ADVWSOFRT3',
    ExclusionOFfers:{GOOGLESTADIA_3MO_SPCLDISCOUNT:'STREAMTV_ACQ_VZREWARD|MnM_$100CARD_DISCOUNT_GPONiONT_VZREWARD|FCP_$100CARD_DISCOUNT_GPONiONT_VZREWARD|',AMAZON_ECHODOT_SMARTPLUG_SPCLDISCOUNT:'DISNEYPLUS_12MO_SPCLDISCOUNT|$50_VERIZON_GIFT_CARD_DISCOVERYPLUS_iONT_Bonus_VZREWARD|',AMAZON_SHOW5_SPCLDISCOUNT:'$50_VERIZON_GIFT_CARD_DISCOVERYPLUS_iONT_Bonus_VZREWARD|',AMAZON_SHOW5_RING_SPCLDISCOUNT:'$100_VERIZON_GIFT_CARD_DISCOVERYPLUS_GPON iONT_VZREWARD|$100_VERIZON_GIFT_CARD_DISCOVERYPLUS_iONT_Bonus_VZREWARD|$100_VERIZON_GIFT_CARD_DISCOVERYPLUS_VZREWARD|',FIOS200_JMPADD:'DISNEYPLUS_12MO_SPCLDISCOUNT|STREAMTV_ACQ_VZREWARD|HULUSVOD_12MO_VZREWARD|AMC_12MTH_FIOS_SPCLDISCOUNT|ADVBSMRKT3_JMPADD|$200_VERIZON_GC_DISCOUNT_SPCLDISCOUNT|',FIOS100_JMPADD:'DISNEYPLUS_12MO_SPCLDISCOUNT|STREAMTV_ACQ_VZREWARD|HULUSVOD_12MO_VZREWARD|',SONY_PLAYSTATION_3MONTH_SPCLDISCOUNT:'$50_VERIZON_GIFT_CARD_DISCOVERYPLUS_iONT_Bonus_VZREWARD|',SONY_PLAYSTATION_ACQBLACKFRIDAY2020:'$100_VERIZON_GIFT_CARD_DISCOVERYPLUS_GPON iONT_VZREWARD|$100_VERIZON_GIFT_CARD_DISCOVERYPLUS_VZREWARD|$50_VERIZON_GIFT_CARD_DISCOVERYPLUS_iONT_Bonus_VZREWARD|DISCOVERYPLUS_12MO_GPON iONT_SPCLDISCOUNT|',$100_VERIZON_GIFT_CARD_DISCOUNT_VZREWARD:'$100_VERIZON_GIFT_CARD_DISCOVERYPLUS_GPON iONT_VZREWARD|$100_VERIZON_GIFT_CARD_DISCOVERYPLUS_iONT_Bonus_VZREWARD|$100_VERIZON_GIFT_CARD_DISCOVERYPLUS_VZREWARD|',$50_VERIZON_GIFT_CARD_DISCOUNT_VZREWARD:'$50_VERIZON_GIFT_CARD_DISCOVERYPLUS_iONT_Bonus_VZREWARD|',DISCOVERYPLUS_12MO_SPCLDISCOUNT:'DISCOVERYPLUS_12MO_GPON iONT_SPCLDISCOUNT|',
    AMAZON_ECHOSPEAKER_RING_SPCLDISCOUNT:'AMAZON_ECHODOT_SPCLDISCOUNT',SIMPLISAFE_8_PIECE_BUNDLE_SPCLDISCOUNT:'SONY_PS5_ACQ_HS_VZREWARD',DISNEYBUNDLE_12MO_SPCLDISCOUNT:'SONY_PS5_ACQ_HS_VZREWARD|SONYPULSE3D_WLS_HEADSET_ACQ_HS_VZREWARD',SPR_VIN_NYDMA_SPCLDISCOUNT:'$100_VERIZON_GC_DISCOUNT_VZREWARD|$50_VERIZON_GC_DISCOUNT_VZREWARD|STREAMTVSOUNDBAR_ACQ_VZREWARD',$100_VERIZON_EGIFT_CARD_DISCOUNT_VZREWARD:'AMAZON_ECHODOT_SPCLDISCOUNT',SPR_VIN_PH_BO_DMA_SPCLDISCOUNT:'$10_NURSE_DISC_SPCLDISCOUNT|$100CARD_DISCOUNT_VZREWARD|$200_VERIZON_GC_DISCOUNT_VZREWARD|$100_VERIZON_GC_DISCOUNT_VZREWARD|SAMSUNG_TAB_A7_LITE_50_SPCLDISCOUNT|SAMSUNG_CHROME_100_SPCLDISCOUNT|SAMSUNG_CREDIT_50_SPCLDISCOUNT|',STREAMTVSOUNDBAR_ACQ_VZREWARD:'AMC_12MTH_FIOS_SPCLDISCOUNT|$200_VERIZON_GC_DISCOUNT_BF_ACQBLACKFRIDAY2021|$200_VERIZON_GC_DISCOUNT_SPCLDISCOUNT|ADVBSMRKT3_JMPADD|',SPR_VIN_NOT_NYDMA_SPCLDISCOUNT:'AMC_12MTH_FIOS_SPCLDISCOUNT|$50_VERIZON_GC_DISCOUNT_VZREWARD|$100_VERIZON_GC_DISCOUNT_VZREWARD|$200_VERIZON_GC_DISCOUNT_SPCLDISCOUNT|OneMonth_Internet_disc_SPCLDISCOUNT|',DISNEYPLUS_12MO_SPCLDISCOUNT:'FIOS200_JMPADD'},
    UniqueSpecialOffers:{AMAZON_ECHODOT_SMARTPLUG_SPCLDISCOUNT:'DISNEYPLUS_12MO_SPCLDISCOUNT|',AMAZON_SHOW5_SPCLDISCOUNT:'DISNEYPLUS_12MO_SPCLDISCOUNT|'},
    allFlashOffers: {DATA:'ACQBLACKFRIDAY2020|$100_VZ_GIFT_CARD_BF,ACQBLACKFRIDAY2020|SONY_PLAYSTATION,ACQBLACKFRIDAY2021|NEST_HUBMAX_DATA_BF'},
    allClassicSpecialOffers:'SONY_PLAYSTATION,SONY_PLAYSTATION_3MONTH,AMAZON_SHOW5_RING,AMAZON_SHOW5,AMAZON_ECHODOT_SMARTPLUG,DISCOVERYPLUS_3MO,DISCOVERYPLUS_6MO,DISCOVERYPLUS_12MO,DISCOVERYPLUS_3MO_GPON iONT,DISCOVERYPLUS_6MO_GPON iONT,DISCOVERYPLUS_12MO_GPON iONT',
    MarvelAvenger:'MARVEL_AVENGERS',
    FiftyOfferPYP:'50%OFFPREMIUM',
    Affinity: 'AFFINITY',
    Connection: 'CONNECTIONS',
    DiscoveryPlus: 'DISCOVERYPLUS_12MO',
    amazonPrime:'AMAZON_PRIME_12MO',
    samsung:'SAMSUNG',
    samsung$100 : 'SAMSUNG_CHROME_100',
    vintageOffer : 'SPR_VIN_PH_BO_DMA',
    vintageOfferQualified : 'SPR_VIN_NYDMA',
    PreholidayOffer : '$200_VERIZON_GC_DISCOUNT',
    PreholidayOffer100 : '$100_VERIZON_GC_DISCOUNT',
    BlackFridayGC : '$200_VERIZON_GC_DISCOUNT_BF_ACQBLACKFRIDAY2021',
    BlackFridayNest : 'NEST_HUBMAX_DATA_BF_ACQBLACKFRIDAY2021',
    FIOS_LOCALJBLPARTYBOX: 'FIOS_LOCALJBLPARTYBOX',
    FIOS_NFLSUNTK: 'FIOS_NFLSUNTK',
    NetmaxOnUs: 'NETMAX_PERK_DISCOUNT'
}

export const DOID = {
    targetDoid: 'BYOB_Triple_Custom1G_2YR_ALT',
}

export const Moves = {
    Seamless: 'SEAMLESS_MOVES',
    UPDATE_CUST_OPT: "UPDATE_CUST_OPT"
}

export const PAGEACTIVITY =
{
    PAGE:{
        LQ: 'LOOPQUAL',
        TWS: 'TWSDISCOUNT',
        BYOB: 'BUILDPRODUCT',
        FIFTENG: '15G',
        CO: 'CHECKOUT',
        CART:'CART',
        RC:'RETRIEVECART',
        SMRY: 'SUMMARY',
        CI:'CONTACTINFO',
        ASYNC:'ASYNCAPI',
        CC:'CREDITCHECK',
        INST:'INSTALLATION',
        PFB:'PAPERFREEBILL',
        AP:'AUTOPAY',
        TOS:'TERMSOFSERVICE',
        DP:'DEPOSIT',
        PO: 'PLACEORDER',
        RTA:'RTA',
        FB:'FINALBILL',
        STV:'SATELLITETV',
        CARE:'CAREFLOW',
        SD:'SUPPDETAIL'
    },
    MSG:{
        ZipNotFound:'ZIPNOTFOUND',
        StreetNotFound:'STREETNOTFOUND',
        AddressNotFound:'ADDRESSNOTFOUND',
        unitCount:'UNITCOUNT',
        NoUnit:'NOUNIT',
        mtnEntered:'MTNENTERED',
        emailEntered:'EMAILENTERED',
        RememberMe: 'REMEMBERME',
        HOA:'HOA',
        FIVEG:'FIVEG',
        redirectingBAU:'REDIRECTINGBAU',
        revisit:'REVISITCUSTOMER',
        changeAdr: 'CHANGEADDRESS',
        MultipleAddress:'MULTIPLEADDRESS',
        lqRetry:'LQRETRY',
        lqDataNullRetry:'LQDATANULLRETRY',
        lqDataNullProceed: 'LQDATANULLPROCEED',
        LocusError: 'LOCUSERROR',
        InsideCheckAddr:'INSIDECHECKADDR',
        CheckLQBtnClick:'CHECKLQBTNCLICK',
        ExistingService:'EXISTINGSERVICEFOUND',
        SmartCartFound: 'SMARTCARTFOUND',
        ContinueSmartCart: 'SMARTCARTFOUND-CONTINUE',
        ContinueNewOrder: 'SMARTCARTFOUND-NEW',        
        PendingOrder: 'PENDINGORDERFOUND',
        PendingOrderYes:'PENDINGORDERFOUND-YES',
        PendingOrderNo:'PENDINGORDERFOUND-NO',
        CantFindAddress: 'CANTFINDADDRESS',
        StreetNotFoundinLocus: 'STREETNOTFOUNDINLOCUS',
        StreetfoundinNtas: 'STREETFOUNDINNTAS',
        StreetnotfoundinNtas: 'STREETNOTFOUNDINNTAS',
        UnitNotFoundinLocus: 'UNITNOTFOUNDINLOCUS',
        CantFindUnit:'CANTFINDUNIT',
        HelpClick:'HELPCLICK',
        SigninClick:'SIGNINCLICK',
        SigninMHClick: 'SIGNINMHCLICK',
        SigninMHBtnClick: 'SIGNINMHBTNCLICK',
        SkipForNowBtnClick: 'SKIPFORNOWBTNCLICK',
        OOFClick:'OOFCLICK',
        fiveGZip:'FIVEGZIP',
        OneLQFlow: 'ONELQFLOW',
        VisitIdEmpty: 'REDIRECTED-AS-VISITIDEMPTY',
        CaptchaShown: 'CAPTCHASHOWN',        
        CaptchaSuccess: 'CAPTCHASUCCESS',
        CaptchaFailure: 'CAPTCHAFAILURE',
        OneLqFiosQual: 'ONELQFIOSQUAL',
        OneLq5GQual: 'ONELQ5G',
        OneLqredirectingBAU:'ONELQREDIRECTINGBAU',
        AddressLength: 'ADDRESSLENGTH',
        OneLqNonFDVEligible: 'ONELQ-FIOS-NONFDV',
        NonFDVEligible: 'FIOS-NONFDV',
        lqError:'LQERROR',
        productNotFound:'PRODUCTNOTFOUND',
        productFound:'PRODUCTFOUND',
        apiResponseFailed:'APIRESPONSEFAILED',
        error_404:'ERROR_404',
        error_412:'ERROR_412',
        responseEmpty:'RESPONSEEMPTY',
        notAvailable:'NOTAVAILABLE',
        available:'AVAILABLE',
        m2m:'M2M',
        twoyear:'2YR',
        CCCompleted:'CCCOMPLETED',
        personalInfoCompleted:'PERSONALINFOCOMPLETED',
        showLBO:'SHOWLBO',
        couponInfoExists:'COUPONINFOEXISTS',
        retrieveFailedCart:'RETRIEVEFAILED-CART',
        resumeMONError:'RESUMEMONERROR',
        resumeWB:'RESUMEWINBACKTN',
        resumeDepositRequired:'RESUMEDEPOSITREQUIRED',
        retrieveCartResponseEmptyorNull:'RETRIEVECART-RESPONSEEMPTYORNULL',
        retrieveCartDataNull:'RETREIVECART-DATANULL',
        redirectToCheckout:'REDIRECTTOCHECKOUT',
        redirectToBuildProducts:'REDIRECTTOBUILDPRODUCTS',        
        cartEmpty:'CARTEMPTY',
        cartResponseNull:'CARTRESPONSE-NULL',
        cartServiceNull:'CARTSERVICE-NULL',
        LD : 'LOADED',
        CD : 'COMPLETED',
        lboRedirectOOF:'LBOREDIRECTOOF',
        changeinadrId:'CHANGEINADRID',
        suppBuildPrdBack:'SUPPBUILDPRD-BACK',
        businessType:'BusinessType',
        callValidateAPIFailure: 'CALLVALIDATEAPIFAILURE'
    },
    UA:'USERACTION'
}
export const BuffaloDMA = {
    BuffaloDMA : [ 14010,14026,14031,14032,14033,14043,14051,14057,14059,14068,14075,14085,14086,14120,14127,14150,
    14170,14206,14207,14210,14214,14215,14216,14217,14218,14219,14220,14221,14223,14224,14225,14226,
    14227,14228 ]
}
export const ChangeAppActionTypes = {
    MnHOneClick: {
        marketingProfileResp: 'UPDATE_MARKETING_PROFILE_RESP',
        loopQualResp: 'LOOP_QUALE_RESP',
        locusAddressValidationResp: 'UPDATE_LOCUS_ADDRESS_VALIDATION_RESP',
        oneCreditResp: 'UPDATE_ONE_CREDIT_RESP',
        crmmStandaloneResp: 'UPDATE_CRMM_STANDALONE_RESP',
        crmmBundleResponse: 'UPDATE_CRMM_BUNDLE_RESP',  
        crmmPromoResponse: 'UPDATE_CRMM_PROMO_RESP',  
        crmmEquipmentResponse: 'UPDATE_CRMM_EQUIPMENT_RESP', 
        crmmVasResponse: 'UPDATE_CRMM_VAS_RESP',  
        vzwOfferEligibilityResp: 'UPDATE_VZW_OFFER_ELIGIBILITY_RESP'
    },
    PortingTool: {
        sspGridResp: 'UPDATE_SSP_GRID_RESP',
        marketingProfileResp: 'UPDATE_MARKETING_PROFILE_RESP',
        loopQualResp: 'LOOP_QUALE_RESP'
    }

}

export const PegaEP = {
    renewalBundlePlans: 'RENEWALBUNDLEPLANS',
    bundleDetails: 'BUNDLEDETAILS',
    installation: 'INSTALLATION',
    review: 'REVIEW',
    confirmation: 'CONFIRMATION'
}

export const offerText = {
    marvelAvenger:'Marvels Avengers game and Hero Outfits',
    hulu12:'Hulu for 12 Months'

}

export const FlowRoute = {
    classicToFCP: 'CLASSICTOFCP',
    internet: 'INTERNET',
    router: 'ROUTER',
    extender: 'EXTENDER'
}
export const TVUSOCS = {
    //// R0558 - Most Fios TV ,R0557-Your Fios TV
    newUsocs :['R0476','R0477','R0474','R0475','R0473','R0478','R0557','R0558','R0554','R0555','R0556'],
    oldUsocs :['Q6456','Q6457','Q6454','Q9599','Q6453','Q7818','R0476','R0477','Q6453','Q6454','Q9599'],
    newTVUsocs:['R1374','R1375','R1372','R1373','R0554','R1376','R0557','R0558','R0554','R0555','R0556'],
    newMMTVUsocs:['R1773','R1774','R1771','R1772','R1770','R1775','R0557','R0558','R0554','R0555','RO556']
}

export const VBMMessageISOCS = ['R2055','R1921','R2172','R2173','R2174','R2175','R2055','R1649','R1650','R1651']

export const threeChannelLineups = [
    {
      name: 'viewByChannelsGroupRadio',
      label: 'A-Z',
      // children: 'Placeholder Text',
      value: 'azOne',
      ariaLabel: 'A-Z',
      id:"atoz",
      disabled: false
    },            
    {
      name: 'viewByChannelsGroupRadio',
      label: 'Category',
      // children: 'Placeholder Text',
      value: 'categoryTwo',
      ariaLabel: 'Category',
      id:"Category",
    },              
    {
      name: 'viewByChannelsGroupRadio',
      label: 'Channels',
      // children: 'Placeholder Text',
      value: 'ChannelsThree',
      ariaLabel: 'Channels',
      id:"channel",
    }
  ]

  export const fourthChannelLineups = [
    {
      name: 'viewByChannelsGroupRadio',
      label: 'A-Z',
      // children: 'Placeholder Text',
      value: 'azOne',
      ariaLabel: 'A-Z',
      id:"atoz",
      disabled: false
    },            
    {
      name: 'viewByChannelsGroupRadio',
      label: 'Category',
      // children: 'Placeholder Text',
      value: 'categoryTwo',
      ariaLabel: 'Category',
      id:"Category",
    },              
    {
      name: 'viewByChannelsGroupRadio',
      label: 'Channels',
      // children: 'Placeholder Text',
      value: 'ChannelsThree',
      ariaLabel: 'Channels',
      id:"channel",
    },
        {
          name: 'viewByChannelsGroupRadio',
          label: 'Gain & Lose',
          // children: 'Placeholder Text',
          value: 'gainloseFour',
          ariaLabel: 'gainlose',
          id:"gainlose",
        }
  ]